import React from "react";
import PropTypes from 'prop-types';

const Input = ({
  title,
  value,
  setValue,
  placeholder = '',
  type = 'text',
  className = '',
  disable = false,
  rows = 3,
  required = false
}) => (
  <div className={className}>
    <label>{title} {required && <span style={{ color: 'red' }}>*</span>}</label>
    {
      type == "textarea" ? (
        <textarea
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={placeholder}
          rows={rows}
          disabled={disable}
        ></textarea>
      )
        : (
          <input
            type={type}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder={placeholder}
            disabled={disable}
          />
        )
    }
  </div>
);

Input.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  setValue: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
  disable: PropTypes.bool,
  required: PropTypes.bool,
  rows: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
};

export default Input;